import {get, has, set} from '@aofl/object-utils';

const ARRAY_KEY_REGEX = /\[\]$/;

class SearchParams {
  static encode(queryObj, nestedKeyPrefix = '') {
    const parts = [];
    for (const key in queryObj) {
      if (!queryObj.hasOwnProperty(key)) continue;
      const encodedKey = encodeURIComponent(nestedKeyPrefix + key);
      const val = queryObj[key];
      if (Array.isArray(val)) {
        for (let i = 0; i < val.length; i++) {
          parts.push(encodedKey + '[]=' + encodeURIComponent(val[i]));
        }
      } else if (typeof val === 'object') {
        parts.push(SearchParams.encode(val, `${nestedKeyPrefix}${key}.`));
      } else {
        parts.push(encodedKey + '=' + encodeURIComponent(val));
      }
    }
    return parts.filter((item) => item !== '').join('&');
  }

  static decode(searchParams) {
    const queryObj = {};

    searchParams.forEach((value, key) => {
      try {
        if (typeof value === 'string') {
          value = JSON.parse(value); // correctly type cast bool,number,...
        }
      } catch (e) {}
      const keyIsArray = ARRAY_KEY_REGEX.test(key);
      if (keyIsArray) {
        key = key.replace(ARRAY_KEY_REGEX, '');
      }

      if (has(queryObj, key)) {
        const currentVal = get(queryObj, key);
        if (Array.isArray(currentVal)) {
          currentVal.push(value);
        } else {
          set(queryObj, key, [currentVal, value]);
        }
      } else {
        if (keyIsArray) {
          value = [value];
        }
        set(queryObj, key, value);
      }
    });

    return queryObj;
  }
}

export {
  SearchParams
};
